module.exports = __webpack_public_path__ + "img/53.10.pH.07c9b5b6.png";